export enum ScreenSizes {
  Desktop = 1450,
  LargeMobile = 768,
  Mobile = 500,
  SmallMobile = 320,
  Tablet = 1024,
}
